export default "__VITE_ASSET__B3Ky3BFg__"